import {
  SET_FIRST_DAY_OF_WEEK,
  SET_LOCALISATION_VARS,
  SET_TRANSLATIONS,
} from '../helpers/constants/actionsConstants';

import type {
  SetFirstDayOfWeekAction,
  SetLocalisationVarsAction,
  SetTranslationsAction,
} from './types';

type Translations = Record<string, string>;

const setTranslations = (
  translations: Translations,
): SetTranslationsAction => ({
  type: SET_TRANSLATIONS,
  payload: translations,
});

const setLocalisationVars = (
  locale: string,
  market: string,
  currency: string,
): SetLocalisationVarsAction => ({
  type: SET_LOCALISATION_VARS,
  payload: {
    locale,
    market,
    currency,
  },
});

const setFirstDayOfWeek = (
  firstDayOfWeek: 0 | 1 | 2 | 3 | 4 | 5 | 6,
): SetFirstDayOfWeekAction => ({
  type: SET_FIRST_DAY_OF_WEEK,
  payload: firstDayOfWeek,
});

export { setTranslations, setLocalisationVars, setFirstDayOfWeek };
